<template>
  <div class="search-container">
    <h5 class="search-label" v-if="label">{{ label }}</h5>
    <nav class="navbar navbar-light">
      <div class="form-inline">
        <input
          :value="value"
          @input="$emit('input', $event.target.value)"
          class="form-control mr-sm-2"
          type="search"
          :placeholder="placeholder"
          aria-label="Search"
        />
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'VSearch',
  props: {
    label: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      value: null,
    };
  },
};
</script>

<style scoped lang="scss">
input[placeholder] {
  text-overflow: ellipsis;
}
.container {
  .search {
    &-container {
      display: flex;
      align-items: baseline;
      margin-bottom: 1em;
    }

    &-label {
      margin-right: 0.5em;
    }
  }
}
</style>
